// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__2SFGM","logo_sidebar":"logo_logo_sidebar__2-dkg","img":"logo_img__23225"};